import { RiskAssessmentStatus } from './enums';

export class LocationInfo {
    public id: string;
    public number: string;
    public name: string;
    public pollutionStatusCode: string;
    public isLandfill: boolean;
    public constructor(init: Partial<LocationInfo>) {
        Object.assign(this, init);
    }
}

export class CaseWorker {
    public id: string;
    public name: string;
    public email: string;
    public cvr: string;
    public region: number;

    public constructor(init: Partial<CaseWorker>) {
        Object.assign(this, init);
    }
}

export class CalculationCompound {
    public id: string;
    public name: string;
    public alternativeName: string;
    public group: string;
    public standat?: number;
    public scCode: number;
    public useInScreening: boolean;
    public useInRiskAssessment: boolean;
    public scCodeId?: number;
    public casNo: string;
    public drinkingWaterQualityCriterion?: number;
    public groundWaterQualityCriterion?: number;
    public fictitiousCriterion?: number;
    public molecularWeight?: number;
    public henrysConstant?: number;
    public diffusionCoefficient: FreeDiffusionCoefficient;
    public anaerobicDegradationRate: HorizontalFirstOrderDegradationRate;
    public aerobicDegradationRate: HorizontalFirstOrderDegradationRate;
    public verticalFirstOrderDegradationRate?: number;
}

export class HorizontalFirstOrderDegradationRate {
    public value?: number;
    public average?: number;

    public constructor(init: Partial<HorizontalFirstOrderDegradationRate>) {
        Object.assign(this, init);
    }
}

export class FreeDiffusionCoefficient {
    public air?: number;
    public water?: number;

    public constructor(init: Partial<FreeDiffusionCoefficient>) {
        Object.assign(this, init);
    }
}

export class CalculationInputScreeningData {
    public infiltration: number;
    public aquiferDepth: number;
    public distanceToAbstractionWell: number;
    public hydraulicConductivity: number;

    public constructor(init: Partial<CalculationInputScreeningData>) {
        Object.assign(this, init);
    }
}

export class Reassessment {
    public reassessedToStatus: RiskAssessmentStatus;
    public reassementDate: Date;
    public comment: string;
    public caseWorker: CaseWorker;

    public constructor(init: Partial<Reassessment>) {
        Object.assign(this, init);
    }
}

export class EmbeddedTokenModel {
    public id: string;
    public embedUrl: string;
    public token: string;
    public expiration: Date;
    public minutesToExpiration: number;
    public constructor(init: Partial<EmbeddedTokenModel>) {
        Object.assign(this, init);
    }
}
